import React from "react";


type CepInputProps = {
    value: string; // always plain digits (no mask)
    onChange: (value: string) => void;
    label?: string;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'>;

export const CepInput: React.FC<CepInputProps> = ({ value, onChange, label, ...rest }) => {
    // value is always plain digits ("12345678")
    // show as 99999-999
    const masked = value
        ? value.replace(/(\d{5})(\d{1,3})?/, (m, p1, p2) => (p2 ? `${p1}-${p2}` : p1))
        : "";

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Remove tudo que não for número
        const digits = e.target.value.replace(/\D/g, "").slice(0, 8);
        onChange(digits);
    };

    return (
        <div>
            {label && <label className="titulo_15 titulo_700">{label}</label>}
            <input
                type="text"
                inputMode="numeric"
                maxLength={9}
                value={masked}
                onChange={handleChange}
                {...rest}
            />
        </div>
    );
};
